module.exports = __webpack_public_path__ + "static/media/Suriname.87aad4ca.png";